/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NewCourierBill
 */
export interface NewCourierBill {
    /**
     * 
     * @type {string}
     * @memberof NewCourierBill
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof NewCourierBill
     */
    amount?: number;
    /**
     * 
     * @type {Date}
     * @memberof NewCourierBill
     */
    dateDue?: Date;
    /**
     * 
     * @type {Date}
     * @memberof NewCourierBill
     */
    datePaid?: Date;
    /**
     * 
     * @type {string}
     * @memberof NewCourierBill
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof NewCourierBill
     */
    paymentMethod?: string;
    /**
     * 
     * @type {Date}
     * @memberof NewCourierBill
     */
    dateCreated?: Date;
    /**
     * 
     * @type {number}
     * @memberof NewCourierBill
     */
    courierId?: number;
    /**
     * 
     * @type {number}
     * @memberof NewCourierBill
     */
    planId?: number;
}

/**
 * Check if a given object implements the NewCourierBill interface.
 */
export function instanceOfNewCourierBill(value: object): value is NewCourierBill {
    return true;
}

export function NewCourierBillFromJSON(json: any): NewCourierBill {
    return NewCourierBillFromJSONTyped(json, false);
}

export function NewCourierBillFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewCourierBill {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'] == null ? undefined : json['description'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'dateDue': json['dateDue'] == null ? undefined : (new Date(json['dateDue'])),
        'datePaid': json['datePaid'] == null ? undefined : (new Date(json['datePaid'])),
        'status': json['status'] == null ? undefined : json['status'],
        'paymentMethod': json['paymentMethod'] == null ? undefined : json['paymentMethod'],
        'dateCreated': json['dateCreated'] == null ? undefined : (new Date(json['dateCreated'])),
        'courierId': json['courierId'] == null ? undefined : json['courierId'],
        'planId': json['planId'] == null ? undefined : json['planId'],
    };
}

export function NewCourierBillToJSON(json: any): NewCourierBill {
    return NewCourierBillToJSONTyped(json, false);
}

export function NewCourierBillToJSONTyped(value?: NewCourierBill | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'description': value['description'],
        'amount': value['amount'],
        'dateDue': value['dateDue'] == null ? undefined : ((value['dateDue']).toISOString()),
        'datePaid': value['datePaid'] == null ? undefined : ((value['datePaid']).toISOString()),
        'status': value['status'],
        'paymentMethod': value['paymentMethod'],
        'dateCreated': value['dateCreated'] == null ? undefined : ((value['dateCreated']).toISOString()),
        'courierId': value['courierId'],
        'planId': value['planId'],
    };
}

